<template>
  <div v-if="visible" class="bimplusfilter">
    <header class="bimplusfilter-head">
      <div class="column">
        <div class="columns">
          <div class="column is-flex is-align-items-center">
             <i class="icon-modelfilter has-text-black-bis"></i>
             <div class="is-divider-vertical my-0"></div>
              <h3 class="is-italic has-text-weight-semibold has-text-black-bis">
                MODEL FILTERS
              </h3>
          </div>
          <div class="column  is-flex is-narrow is-align-items-center">
            <div class="is-divider-vertical my-0"></div>
             <i class="icon-close has-text-black-bis" @click="$emit('close')"></i>
          </div>
        </div>
      </div>  
    </header>
    <div class="bimplusfilter-body is-visible has-background-white">
      <div class="column">
        <div class="columns">
          <div class="column">
            <h3 class="is-italic has-text-weight-semibold has-text-black-bis">Location</h3>
            <mf-multi-select v-model="selectedLoc"
              track-by="_id" label="name"
              :preselect-first="true"
              openDirection="below"
              :disabled="allLocations.length === 0"
              :placeholder="getPlaceHolder"
              :sort="false"
              :options="allLocations"
              :searchable="true"
              :allow-empty="false">
            </mf-multi-select>
          </div>
          <div class="column">
            <h3  class="is-italic has-text-weight-semibold has-text-black-bis">Owner</h3>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <h3  class="is-italic has-text-weight-semibold has-text-black-bis">Stage</h3>
          </div>
          <div class="column">
            <h3  class="is-italic has-text-weight-semibold has-text-black-bis">Status</h3>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="columns">
          <div class="column">
            <div class="field">
              <div class="field-label">
                <label class="label has-text-left">Coordinate By</label>
              </div>
              <div class="field-body">
                <mf-date
                  :item="newDelivery"
                  :input-props="{
                    kind: '_delivery.deliverBy',
                    min: '_delivery.deliveryStart',
                  }"
                  :is-edit="true"
                >
                </mf-date>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <div class="field-label">
                <label class="label has-text-left">Detail By</label>
              </div>
              <div class="field-body">
                <!-- <mf-date
                  :item="newDelivery"
                  :input-props="{
                    kind: '_delivery.deliverBy',
                    min: '_delivery.deliveryStart',
                  }"
                  :is-edit="true"
                >
                </mf-date> -->
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <div class="field-label">
                <label class="label has-text-left">Manufacture By</label>
              </div>
              <div class="field-body">
                <!-- <mf-date
                  :item="newDelivery"
                  :input-props="{
                    kind: '_delivery.deliverBy',
                    min: '_delivery.deliveryStart',
                  }"
                  :is-edit="true"
                >
                </mf-date> -->
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <div class="field-label">
                <label class="label has-text-left">QA/QC By</label>
              </div>
              <div class="field-body">
                <!-- <mf-date
                  :item="newDelivery"
                  :input-props="{
                    kind: '_delivery.deliverBy',
                    min: '_delivery.deliveryStart',
                  }"
                  :is-edit="true"
                >
                </mf-date> -->
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <div class="field-label">
                <label class="label has-text-left">Onsite By</label>
              </div>
              <div class="field-body">
                <!-- <mf-date
                  :item="newDelivery"
                  :input-props="{
                    kind: '_delivery.deliverBy',
                    min: '_delivery.deliveryStart',
                  }"
                  :is-edit="true"
                >
                </mf-date> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="bimplusfilter-footer is-align-items-center is-flex is-justify-content-center">
      <div class="column">
        <div class="columns">
          <div class="column pl-0">
              <button class="button is-outlined" @click="cancel()">Clear Filters</button>
          </div>
          <div class="column is-justify-content-flex-end is-align-items-center is-flex pr-0">
            <button class="button is-outlined mr-2" @click="
              $emit('close-modal')">
              Cancel</button>
            <button
            class="button has-background-black-bis has-text-white" @click="applyFilter">
              Apply
            </button>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import {reactive, toRefs, onMounted} from 'vue';
import MfDate from '@/components/abstract/MfDate.vue';
import UtilityMixin from '@/components/mixins/UtilityMixin';
import BimPlusViewer from '../../views/bimplus/bimplusViewer';
import MfMultiSelect from '@/components/abstract/MfMultiSelect';

export default {
  name: 'BimPlusFilter',
  components: {
    'mf-date': MfDate,
    'mf-multi-select': MfMultiSelect
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: String,
      default: '',
    },
    bimplusProjectId: {
      type: String,
      default: '',
    },
    models: {
      type: Array
    }
    
  },
  setup(props) {
    const { getAllLocations } = UtilityMixin();
    const data = reactive ({
      allUsers: [],
      allLocations: [],
      allStages: [],
      allStatus: []
    });

    onMounted( async () => {
      console.log('------>Project ID', props.projectId);
      data.allLocations = await getAllLocations(props.projectId, true);
      console.log('------>Locations', data.allLocations);
    });

    const applyFilter = (async () => {
      console.log('------>From Filter UI Models', props.models);
      let viewer = await BimPlusViewer.filterModels(props.projectId, props.models[0]);
      console.log('------>Viewer', viewer);
    });
    
    return {
      ...toRefs(data),
      applyFilter
    }
  },
}
</script>